import script from "./NotificationBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationBanner.vue?vue&type=script&lang=ts&setup=true"

import "./NotificationBanner.vue?vue&type=style&index=0&id=2dc85340&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc85340"]])

export default __exports__